import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=363838ee&scoped=true&"
import script from "./OrganisationList.vue?vue&type=script&lang=ts&"
export * from "./OrganisationList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&id=363838ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363838ee",
  null
  
)

export default component.exports